import getStore from "../store/store";
import type { MailFolder } from "owa-graph-schema";

export default function getFolderTable(): Map<string, MailFolder> {
    return getStore().folderTable;
}
